import Vue from 'vue';
import Vuex from 'vuex';
import qs from 'qs';
import Cookies from 'js-cookie';
import { common, baseComponents } from '@tencent/ceiba-base-components';
import constant from './constant';
Vue.use(Vuex);

const LOGIN_INVALID_RET = 7000;

// 从url中兼容获取上报的trace_id,放到ext中
const currentQuery = qs.parse(window?.location.search.substring(1));
const reportExt = {};
if (Object.prototype.hasOwnProperty.call(currentQuery, 'trace_id')) {
  reportExt.trace_id = currentQuery.trace_id;
}
if (Object.prototype.hasOwnProperty.call(currentQuery, 'track_id')) {
  reportExt.trace_id = currentQuery.track_id;
}

function getCurrentPageInfo(actInfo) {
  if (
    !actInfo
    || !actInfo.config.configs
    || !actInfo.page_id
    || !actInfo.config.configs[actInfo.page_id]) {
    return {

      canvasConfig: {
        quaFlowId: 0, // 资格流程ID
        background: '',
        backgroundImage: {
          src: '',
        },
        pageMeta: {},
        width: '',
        resolution: '',
        shareConfig: {
          title: '',
          desc: '',
          icon: '',
          link: '',
          switchLink: '',
        },
        dialogConfig: {
          dialogStyle: {},
          closeStyle: {},
          confirmStyle: {},
          cancelStyle: {},
        },
        reportConfig: {},
      },
      componentConfig: [],
    };
  }
  return actInfo.config.configs[actInfo.page_id];
}
function getDeviceMode(actInfo) {
  console.log('state.actInfo.channel_type=', actInfo.channel_type);
  if (Vue.prototype.$developFlag) {
    if (common.platform.device === 'others') {
      return 'pc';
    } if (window && (window.orientation === 90 || window.orientation === -90)) {
      // 移动端横版
      return 'h5-h';
    }
    return 'h5';
  }
  if (actInfo.channel_type === 1) {
    return 'h5';
  } if (actInfo.channel_type === 3) {
    return 'h5-h';
  }
  return 'pc';
}
function getFontSize(actInfo) {
  const deviceMode = getDeviceMode(actInfo);
  let fontSize = '16px';
  const rootHtml = document.documentElement;
  console.log(`deviceMode=${deviceMode}|clientWidth=${rootHtml.clientWidth}|clientHeight=${rootHtml.clientHeight}`);
  if (deviceMode === 'pc') {
    fontSize = '16px';
  } if (deviceMode === 'h5-h') {
    const designRatio = constant.H5_H_DESIGN_WIDTH / constant.H5_H_DESIGN_HEIGHT;
    const currentWhRatio = rootHtml.clientWidth / rootHtml.clientHeight;
    let rectWidth = 0;
    if (currentWhRatio >= designRatio) {
      // 宽高比大于设计稿宽高比，则实际尺寸更宽，则高撑满，两边用实际背景图填充
      rectWidth = designRatio * rootHtml.clientHeight; // 以为实际尺寸是设计稿的1/2
    } else {
      // 宽高比小于设计稿宽高比，则实际尺寸更高，则宽撑满，上下用实际背景图填充
      rectWidth = rootHtml.clientWidth;
    }
    fontSize = `${100 * (rectWidth / constant.H5_H_DESIGN_WIDTH)}px`;
    console.log(`rectWidth=${rectWidth}|fontSize=${fontSize}`);
  } else {
    fontSize = `${100 * (rootHtml.clientWidth / constant.H5_DESIGN_WIDTH)}px`;
  }
  console.log(`fontSize=${fontSize}`);
  return fontSize;
}


export default new Vuex.Store({
  namespaced: true,
  state: {
    // 业务自定义
    customStore: {
    },
    // 动态资格初始化
    quaInfo: {
      // 资格状态
    },
    // 角色相关
    isRoleReady: false,
    roleInfo: {
      partition_name: '',
      partition_id: 0,
      role_name: '',
      role_id: '',
      game_open_id: '',
      game_app_id: '',
      device: '',
      area_id: 0,
      plat_id: 0,
    },
    // 用户相关
    isLogin: false,
    isAuth: false,
    userInfo: {
      uin: '',
      nickName: '',
      loginType: '',
      avatar: '',
    },
    inviteUserInfo: {
      uin: '',
      nickName: '',
      loginType: '',
      avatar: '',
    },
    actInfo: {
      config: {
        configs: {},
      },
    },
  },
  getters: {
    reportExt: () => reportExt,
    customStore: state => state.customStore,
    quaInfo: state => state.quaInfo,
    isLogin: state => state.isLogin,
    isAuth: state => state.isAuth,
    userInfo: state => state.userInfo,
    inviteUserInfo: state => state.inviteUserInfo,
    isRoleReady: state => state.isRoleReady,
    roleInfo: state => state.roleInfo,
    pageInfo: state => getCurrentPageInfo(state.actInfo),
    pageMeta: state => getCurrentPageInfo(state.actInfo).canvasConfig.pageMeta,
    shareConfig: state => getCurrentPageInfo(state.actInfo).canvasConfig.shareConfig,
    dialogConfig: state => getCurrentPageInfo(state.actInfo).canvasConfig.dialogConfig,
    reportConfig: state => getCurrentPageInfo(state.actInfo).canvasConfig.reportConfig,
    rootFontSize: state => getFontSize(state.actInfo),
    actInfo: state => state.actInfo,
    ctx: (state, getters) => ({
      customStore: state.customStore,
      quaInfo: state.quaInfo,
      isLogin: state.isLogin,
      userInfo: state.userInfo,
      inviteUserInfo: state.inviteUserInfo,
      isRoleReady: state.isRoleReady,
      roleInfo: state.roleInfo,
      actInfo: state.actInfo,
      pageInfo: getters.pageInfo,
      pageMeta: getters.pageMeta,
      shareConfig: getters.shareConfig,
      dialogConfig: getters.dialogConfig,
      reportConfig: getters.reportConfig,
    }),
    deviceMode: state => getDeviceMode(state.actInfo),
    /**
    * 检查改活动配置的游戏是否处于正常时间周期，比如处于不删档之后
    */
    isRoleStatusValid: (state) => {
      // 检查是否处于不删档后
      const bushandangTimestamp = state.actInfo.extendConfig.bushandangTimestamp || 0;
      const bushandang = state.actInfo.extendConfig.bushandang || false;
      if (bushandang && bushandangTimestamp > 0 && (new Date().getTime() / 1000) <= bushandangTimestamp) {
        console.log('checkRoleStatusValid false');
        return false;
      }
      console.log('checkRoleStatusValid true');
      return true;
    },
    /**
         * 获取当前cookie参数
         * @returns
         */
    userAuth: () => {
      const acctype = Cookies.get('acctype');
      if (!acctype) {
        const uin = Cookies.get('uin');
        const skey = Cookies.get('skey');
        if (!uin || !skey) {
          return {};
        }
        return {
          'T-OPENID': uin.replace(/^[0o]+/, ''),
          'T-APPID': '',
          'T-ACCESS-TOKEN': skey,
          'T-ACCOUNT-TYPE': 'qq',
        };
      }
      return {
        'T-OPENID': Cookies.get('openid'),
        'T-APPID': Cookies.get('appid'),
        'T-ACCESS-TOKEN': Cookies.get('access_token'),
        'T-ACCOUNT-TYPE': Cookies.get('acctype'),
      };
    },
  },
  actions: {
    /**
     * 检查登录态
     * @param {*} options
     * @returns
     */
    async checkLogin({ commit, getters }, options) {
      try {
        const { isLogin, userInfo } = await Vue.prototype.$login.checkLogin(options);
        console.log('checkLogin ', isLogin, userInfo);
        if (isLogin) {
          commit('UPDATE_USER_INFO', userInfo);
          commit('UPDATE_IS_LOGIN', true);
          const reportConfigData = {
            cus_uin: getters.userAuth['T-OPENID'],
            cus_appid: getters.userAuth['T-APPID'],
          };
          console.log('Logined. reportConfigData is:', reportConfigData);
          // 上报数据增加uin
          window.ceibaReporter && window.ceibaReporter?.setConfig(reportConfigData);
          if (Vue.prototype.$aegis) {
            Vue.prototype.$aegis?.setConfig({
              uin: getters.userAuth['T-OPENID'],
            });
          }
        } else {
          commit('UPDATE_USER_INFO', {});
          commit('UPDATE_IS_LOGIN', false);
        }
        return isLogin;
      } catch (e) {
        console.error('checkLogin fail, err=', e);
        return false;
      }
    },
    /**
     * 注销
     * @returns
     */
    async logout({ commit }) {
      const logout = await Vue.prototype.$login.logout();
      commit('UPDATE_IS_LOGIN', false);
      commit('UPDATE_USER_INFO', {});

      const reportConfigData = {
        cus_uin: '',
        cus_appid: '',
      };
      console.log('Logout. reportConfigData is:', reportConfigData);
      window.ceibaReporter && window.ceibaReporter?.setConfig(reportConfigData);
      typeof window !== 'undefined' && window.aegis && window.aegis.setConfig({
        uin: '',
      });
      return logout;
    },
    /**
         * 去登录
         * @param {*} options
         */
    async login({ }, options) {
      await Vue.prototype.$login.login(options);
    },
    /**
         * 检查最新绑定角色信息
         * @returns
         */
    async checkRoleInfo({ state, commit, dispatch }, options) {
      try {
        return await new Promise(async (resolve) => {
          if (common.platform.isGame) {
            // 通过游戏透传得登录态进行兼容
            const roleInfo = JSON.parse(sessionStorage.ceibaGameInfo || '{}');
            commit('UPDATE_ROLE_INFO', roleInfo);
            commit('UPDATE_IS_ROLE_READY', true);
            // 上报数据设置game openid
            const reportConfigData = {
              gopenid: roleInfo.game_open_id,
              gappid: roleInfo.game_app_id,
            };
            console.log('check Role bind. reportConfigData is:', reportConfigData);
            window.ceibaReporter && window.ceibaReporter?.setConfig(reportConfigData);

            resolve(roleInfo);
          } else {
            const pluginRoleInfoResponse = await Vue.prototype.$login.checkRoleInfo();
            console.log('pluginRoleInfoResponse=', pluginRoleInfoResponse);
            if (pluginRoleInfoResponse.isRoleReady) {
              commit('UPDATE_ROLE_INFO', pluginRoleInfoResponse.roleInfo);
              commit('UPDATE_IS_ROLE_READY', true);
              // 上报数据设置game openid
              const reportConfigData = {
                gopenid: pluginRoleInfoResponse.roleInfo.game_open_id,
                gappid: pluginRoleInfoResponse.roleInfo.game_app_id,
              };
              console.log('check Role bind. reportConfigData is:', reportConfigData);
              window.ceibaReporter && window.ceibaReporter?.setConfig(reportConfigData);
            }
            // 如果业务实现插件，不是默认插件，则不作处理直接退出
            if (!pluginRoleInfoResponse.defaultPlugin) {
              resolve({});
              return;
            }

            // 通用逻辑
            baseComponents.Apis.Game.getBindRole(
              {
                game_code: state.actInfo.game_code,
                device: common.platform.device,
              },
              `${state.actInfo.ast}_act_${state.actInfo.activity_id}`,
            ).then((roleInfo) => {
              console.log('[STORE] getBindRole=', roleInfo);
              commit('UPDATE_ROLE_INFO', roleInfo);
              commit('UPDATE_IS_ROLE_READY', true);
              // 上报数据设置game openid
              const reportConfigData = {
                gopenid: roleInfo.game_open_id,
                gappid: roleInfo.game_app_id,
              };
              console.log('check Role bind. reportConfigData is:', reportConfigData);
              window.ceibaReporter && window.ceibaReporter?.setConfig(reportConfigData);

              resolve(roleInfo);
            })
              .catch(() => {
                // 上报数据置空game openid
                const reportConfigData = {
                  gopenid: '',
                  gappid: '',
                };
                console.log('check Role not bind. reportConfigData is:', reportConfigData);
                window.ceibaReporter && window.ceibaReporter?.setConfig(reportConfigData);
                // 如果要显示绑定角色
                if (options && options.showBindRole) {
                  baseComponents.gameRoleSelect
                    .showGameRoleSelect(state.actInfo.game_code, {
                    })
                    .then((roleInfo) => {
                      console.log('store select role=', roleInfo);
                      dispatch('saveCurrentRole', {
                        isRoleReady: true,
                        roleInfo,
                      });
                    });
                }
              });

            resolve({});
          }
        });
      } catch (e) {
        console.error('checkRoleInfo fail| err=', e);
      }
    },
    /**
     * 保存绑定角色信息，同时同步最新绑定角色给后端
     * @param {*} options
     */
    saveCurrentRole({ state, commit }, { isRoleReady, roleInfo }) {
      console.log('[STORE] saveCurrentRole ', isRoleReady, roleInfo);
      commit('UPDATE_ROLE_INFO', roleInfo);
      commit('UPDATE_IS_ROLE_READY', isRoleReady);
      if (isRoleReady && roleInfo) {
        baseComponents.Apis.Game.bindRole(
          {
            game_code: state.actInfo.game_code,
            device: common.platform.device,
            role: roleInfo,
          },
          `${state.actInfo.ast}_act_${state.actInfo.activity_id}`,
        );
        // 上报数据设置game openid
        const reportConfigData = {
          gopenid: state.roleInfo.game_open_id,
          gappid: state.roleInfo.game_app_id,
        };
        console.log('save Current Role. reportConfigData is:', reportConfigData);
        window.ceibaReporter && window.ceibaReporter?.setConfig(reportConfigData);
      }
    },
    /**
         * 业务自定义store
         * @param {*} options
         */
    setCustomStorage({ commit }, { key, value }) {
      commit('UPDATE_CUSTOM_STORE', key, value);
    },
    /**
         * 获取业务自定义store
         * @param {*} key
         * @returns
         */
    getCustomStore({ state }, key) {
      if (typeof key === 'string') {
        return state.customStore[key];
      }
      return state.customStore;
    },
    /**
         * 刷新当前页面资格状态
         */
    async refreshQua({ getters, commit }) {
      console.log('refreshQua');
      if (Vue.prototype.$isInEditor) return commit('UPDATE_QUA_INFO', {
        1: {
          total: 1,
          remain: 4,
        },
      });
      if (getters.pageInfo.canvasConfig.quaFlowId) {
        const response = await Vue.prototype.$requestInstance.post('/amp2.WPESrv/WPEIndex', {
          biz_id: getters.actInfo.ast,
          act_id: getters.actInfo.activity_id,
          flow_id: getters.pageInfo.canvasConfig.quaFlowId,
          role: getters.roleInfo,
        });
        if (response.ret === 0) {
          const quaMap = JSON.parse(response.data).holdList || {};
          Object.keys(quaMap).forEach((k) => {
            quaMap[k].used = quaMap[k].total - quaMap[k].remain >= 0 ? quaMap[k].total - quaMap[k].remain : 0;
          });
          commit('UPDATE_QUA_INFO', quaMap);
        } else if (response.ret === LOGIN_INVALID_RET) {
          Vue.prototype.alert('登录态过期，请退出重新登录~');
        }
      } else {
        commit('UPDATE_QUA_INFO', {});
      }
    },
    /**
         * 流程引擎请求
         * @param {*} options 流程ID + 参数
         * @returns
         */
    async flowRequest({ state }, { flowId, params }) {
      let extendData = params;
      console.log('[flowRequest] 流程ID=', flowId, '|参数=', extendData);

      if (Vue.prototype.$isInEditor) return {
        ret: 0,
        msg: '',
        data: { ret: 0 },
      };

      if (typeof extendData === 'undefined') {
        extendData = {};
      }
      if (typeof extendData.data !== 'undefined') {
        extendData.data = JSON.parse(extendData.data);
        extendData.data.ceiba_plat_id = common.platform.isAndroid ? 'android' : 'ios';
      } else {
        extendData.data = {
          ceiba_plat_id: common.platform.isAndroid ? 'android' : 'ios',
        };
      }
      extendData.data.user_attach = JSON.stringify({
        nickName: state.userInfo.nickName,
        avatar: state.userInfo.avatar,
      });
      const cInviteCode = common.tool.getQueryparams('c_invite_code');
      if (cInviteCode) {
        extendData.data.cInviteCode = cInviteCode;
      }
      // 业务参数
      if (Vue.prototype.$ast.getFlowRequestExtData) {
        const extData = await Vue.prototype.$ast.getFlowRequestExtData({ flowId, params });
        extendData.data.cExtData = extData || {};
      }

      console.log('extendData=', extendData);
      extendData.data = JSON.stringify(extendData.data);
      const data = Object.assign({
        biz_id: state.actInfo.ast,
        act_id: state.actInfo.activity_id,
        flow_id: flowId,
      }, extendData || {});

      const response = await Vue.prototype.$requestInstance.post(`/amp2.WPESrv/WPEIndex?flowId=${flowId}`, data);
      response.data = JSON.parse(response.data || '{ "ret": -1 }');

      // 处理登录态问题
      console.info('flowRequest response=', response);

      // const loginInvalidRet = [7001, 7002, 7003, 7004, 7005, 7006, 7007, 7008, 7551]
      // if (loginInvalidRet.includes(response.ret)) {
      //   console.error('response login status invalid, response=', response);
      //   response.ret = LOGIN_INVALID_RET;
      //   response.msg = `登录态过期，请退出重新登录~\n ${response.msg}`
      // }

      return response;
    },
    /**
     * 调用钩子方法
     * @param {} state 就是当前state的信息，可以拿到一些用户信息角色信息等
     * @param {*} 钩子参数
     * name: 钩子名，比如before_reward， after_reward
     * options: 钩子传参，每个钩子传参不同，具体要看代码
     * configurationData：当前组件的配置数据，可以拿到一些业务自定义埋点字段等信息
     */
    async doHook({ }, { name, options, configurationData }) {
      console.log('doHook name=', name, 'options=', options, '|configurationData=', configurationData);
      // if (Vue.prototype.$ast && Vue.prototype.$ast.doHook) return await Vue.prototype.$ast.doHook({
      //   state, name, options, configurationData,
      // });
      return true;
    },
    /**
         * milo弹窗方法
         * @param {*} param0
         * @param {*} options
         */
    showDialog({ }, options) {
      window.need('biz.dialog', (Dialog) => {
        Dialog.show({
          id: options.id,
          bgcolor: options.bgcolor || '#000', // 遮罩背景色
          opacity: options.opacity || 70, // 遮罩透明度
          onCloseCallback: options.onCloseCallback || function () {
            console.log('onCloseCallback');
          }, // 关闭后的回调函数,非必要参数
        });
      });
    },
    /**
         * milo关闭弹窗方法
         * @param {*} param0
         */
    hideDialog({ }) {
      window.need('biz.dialog', (Dialog) => {
        Dialog.hide();
      });
    },
    /**
         * 移动端分享
         * @param {*} param0
         * @param {*} options
         */
    doShare({ getters }, options) {
      console.log('options=', options, getters.shareConfig);
      if (typeof window !== undefined && window.TGMobileShare) {
        const createShareMask = () => {
          const maskDiv = document.getElementById('share-mask');
          if (maskDiv instanceof HTMLElement) {
            // 已经存在分享mask,控制显示
            maskDiv.style.display = 'block';
          } else {
            // 分享mask不存在,新建一个
            const shareMaskWrap = document.createElement('div');
            Object.assign(shareMaskWrap, {
              id: 'share-mask',
            });

            shareMaskWrap.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
            shareMaskWrap.style.position = 'fixed';
            shareMaskWrap.style.top = 0;
            shareMaskWrap.style.left = 0;
            shareMaskWrap.style.width = '100%';
            shareMaskWrap.style.height = '100%';
            shareMaskWrap.style.zIndex = 10000;
            shareMaskWrap.onclick = function () {
              closeShareMask();
            };
            const shareMask = document.createElement('div');
            if (getters.shareConfig.shareImage) {
              shareMask.style.width = '7.5rem';
              shareMask.style.height = '6.5rem';
              shareMask.style.position = 'absolute';
              shareMask.style.top = '0.1rem';
              shareMask.style.right = '0.5rem';
              shareMask.style.background = `url(${getters.shareConfig.shareImage}) no-repeat center / 100% 100%`;
            } else {
              shareMask.style.width = '5.43rem';
              shareMask.style.height = '1.68rem';
              shareMask.style.position = 'absolute';
              shareMask.style.top = '0.1rem';
              shareMask.style.right = '0.5rem';
              shareMask.style.background = 'url(//game.gtimg.cn/images/peng/act/a20210709znqm/share.png) no-repeat center / 100% 100%';
            }
            shareMaskWrap.appendChild(shareMask);
            document.body.appendChild(shareMaskWrap);
          }
        };
        if (getters.actInfo.channel_type !== 2 && !common.platform.isWX && !common.platform.isQQ) {
          Vue.prototype.alert('请到微信或QQ打开分享');
          return;
        }
        const closeShareMask = () => {
          const maskDiv = document.getElementById('share-mask');
          maskDiv.style.display = 'none';
        };

        if (common.tool.getQueryparams('arkshare') && common.platform.isQQ && getters.actInfo.ast === 'supercore') {
          console.log('common.platform.isQQ && getters.actInfo.ast === supercore');
          createShareMask();
          window.need && window.need('biz.ark', (arkQQ) => {
            // 均为必填项
            const arkInfo = {
              // 不设置或设置为空时，页面有title，则调取title
              title: options.title || getters.shareConfig.title || '',
              // 不设置或设置为空时，页面有Description，则调取Description
              desc: options.desc || getters.shareConfig.desc || '',
              // 分享图片尺寸200*200，大小控制在10k左右，且填写绝对路径
              preview: options.icon || getters.shareConfig.icon || '',
              // 分享链接要跟当前页面同域名(手Q分享有这个要求) ,不设置或设置为空时，默认调取当前URL
              jumpUrl: options.link || getters.shareConfig.link || window.location.href,
              // 玩家收到的推送消息的提示
              prompt: options.title || getters.shareConfig.title || '腾讯游戏',
              successCallback: () => {
                closeShareMask();
                if (options.callback) options.callback();
                console.log('【成功】分享给QQ好友！');
              }, // 类型：function，成功回调函数
              failCallback: (res) => {
                closeShareMask();
                console.log('分享失败：res=', res);
              }, // 类型：function，失败回调函数
            };
            // 设置 setShareInfo 也就是默认分享信息，微信、朋友圈等生效
            arkQQ.init(arkInfo);
            // 拉起qq的好友列表，直接分享
            // arkQQ.share(arkInfo);
          });
          return;
        }
        window.TGMobileShare({
          reportTcss: false,
          // 不设置或设置为空时，页面有title，则调取title
          shareTitle: options.title || getters.shareConfig.title || '',
          // 不设置或设置为空时，页面有Description，则调取Description
          shareDesc: options.desc || getters.shareConfig.desc || '',
          // 分享图片尺寸200*200，大小控制在10k左右，且填写绝对路径
          shareImgUrl: options.icon || getters.shareConfig.icon || '',
          // 分享链接要跟当前页面同域名(手Q分享有这个要求) ,不设置或设置为空时，默认调取当前URL
          shareLink: options.link || getters.shareConfig.link || window.location.href,
          // 点击流命名，用于统计分享量，专题一般采用目录名称如a20151029demo
          actName: `ceiba_${getters.actInfo.activity_id}`,
          // 初始化完成的回调方法，tgms参数为Object类型，有isWX，isQQ，fileName，tcssName四个属性
          onInit(tgms) {
            console.log('onInitShare=', tgms);
            createShareMask();
          },
          // 12个分享回调方法（分享成功和取消分享）,回调方法中无需再加分享tcss统计代码，组件默认已加了
          onShare: {
            WXToMessageSuccess() {
              closeShareMask();
              if (options.callback) options.callback();
              console.log('【成功】分享给微信好友！');
            },
            WXToMessageCancel() {
              closeShareMask();
              console.log('【取消】分享给微信好友！');
            },
            WXToTimelineSuccess() {
              closeShareMask();
              if (options.callback) options.callback();
              console.log('【成功】分享给微信朋友圈！');
            },
            WXToTimelineCancel() {
              closeShareMask();
              console.log('【取消】分享给微信朋友圈！');
            },
            QQToQQSuccess() {
              closeShareMask();
              if (options.callback) options.callback();
              console.log('【成功】分享给QQ好友！');
            },
            QQToQQCancel() {
              closeShareMask();
              if (options.callback) options.callback();
              console.log('【取消】分享给QQ好友！');
            },
            QQToQzoneSuccess() {
              closeShareMask();
              if (options.callback) options.callback();
              console.log('【成功】分享给QQ空间！');
            },
            QQToQzoneCancel() {
              closeShareMask();
              console.log('【取消】分享给QQ空间！');
            },
            QQToMessageSuccess() {
              closeShareMask();
              if (options.callback) options.callback();
              console.log('【成功】分享给微信好友！');
            },
            QQToMessageCancel() {
              closeShareMask();
              console.log('【取消】分享给微信好友！');
            },
            QQToTimelineSuccess() {
              closeShareMask();
              if (options.callback) options.callback();
              console.log('【成功】分享给微信朋友圈！');
            },
            QQToTimelineCancel() {
              closeShareMask();
              console.log('【取消】分享给微信朋友圈！');
            },
          },
        });
      }
    },
    /**
     * 刷新report缓存
     */
    reportFlush() {
      window.ceibaReporter && window.ceibaReporter?.flush();
    },
    /**
     * 封装ceiba点击事件上报
     * @param {Object} param0 解构store公共方法
     * @param {Object} options 需要业务传入的参数
     * @param {String} options.ceibaComponentId ceiba组件注册id
     * @param {String} options.ceibaComponentUid ceiba组件实例化uuid
     * @param {String} options.ceibaComponentUname ceiba组件实例化uname
     */
    reportClick({ state }, options = {}) {
      const ceibaBaseExt = {
        ceiba_business_id: state.actInfo.ast,
        ceiba_activity_id: state.actInfo.activity_id,
        ceiba_page_id: state.actInfo.page_id,
        ceiba_activity_type: state.actInfo.activity_type,
        ceiba_is_truly_login: state.isLogin,
      };
      ceibaBaseExt.ceiba_component_id = options.ceibaComponentId;
      ceibaBaseExt.ceiba_component_uid = options.ceibaComponentUid;
      ceibaBaseExt.ceiba_component_uname = options.ceibaComponentUname;
      // ceiba组件通用点击event_id
      const trackClickOption = {
        page_id: window.reportPageId,
        activity_id: state.actInfo.uo_id, // 增加上报uo活动id
        event_id: '1045',
        game_id: String(state.actInfo?.gid), // 取心悦gid为game_id
        data_id: state.actInfo.report_config['1045'],
        ceiba_ext: JSON.stringify(ceibaBaseExt),
        ext: reportExt,
      };
      window.ceibaReporter && window.ceibaReporter?.trackClick(trackClickOption);

      if (ceibaBaseExt.ceiba_component_uid && state.actInfo.flattenComponents) {
        trackClickOption.component_config = state.actInfo.flattenComponents[ceibaBaseExt.ceiba_component_uid] || {};
      }
      Vue.prototype.$report?.trackClick(trackClickOption);
    },
    /**
     * 封装ceiba曝光事件上报
     * @param {Object} param0 解构store公共方法
     * @param {Object} options 需要业务传入的参数
     * @param {String} options.ceibaComponentId ceiba组件注册id
     * @param {String} options.ceibaComponentUid ceiba组件实例化uuid
     * @param {String} options.ceibaComponentUname ceiba组件实例化name
     */
    reportExpose({ state }, options = {}) {
      const ceibaBaseExt = {
        ceiba_business_id: state.actInfo.ast,
        ceiba_activity_id: state.actInfo.activity_id,
        ceiba_page_id: state.actInfo.page_id,
        ceiba_activity_type: state.actInfo.activity_type,
        ceiba_is_truly_login: state.isLogin,
      };
      ceibaBaseExt.ceiba_component_id = options.ceibaComponentId;
      ceibaBaseExt.ceiba_component_uid = options.ceibaComponentUid;
      ceibaBaseExt.ceiba_component_uname = options.ceibaComponentUname;
      // ceiba组件通用点击event_id
      const trackClickOption = {
        page_id: window.reportPageId,
        activity_id: state.actInfo.uo_id, // 增加上报uo活动id
        event_id: '1044',
        event_type: 1001,
        game_id: String(state.actInfo?.gid), // 取心悦gid为game_id
        data_id: state.actInfo.report_config['1044'],
        ceiba_ext: JSON.stringify(ceibaBaseExt),
        ext: reportExt,
      };
      window.ceibaReporter && window.ceibaReporter?.trackClick(trackClickOption);
      if (ceibaBaseExt.ceiba_component_uid && state.actInfo.flattenComponents) {
        trackClickOption.component_config = state.actInfo.flattenComponents[ceibaBaseExt.ceiba_component_uid] || {};
      }
      Vue.prototype.$report?.trackClick(trackClickOption);
    },
    /**
     * 封装ceiba点击事件上报,暴露部分mantaSDK原始参数
     * @param {Object} param0 解构store公共方法
     * @param {Object} options 需要业务传入的参数
     * @param {String} options.ceibaComponentId ceiba组件注册id
     * @param {String} options.ceibaComponentUid ceiba组件实例化uuid
     * @param {String} options.ceibaComponentUname ceiba组件实例化name
     * @param {String} options.eventId 产品事先申请,约定好的事件id[非必填]
     * @param {Number} options.eventType 产品事先申请,约定好的事件type
     * @param {String} options.eventKey 产品事先申请,约定好的事件英文key,优先级比eventId低.当没有指定eventId时尝试从此参数获取eventId[非必填]
     * @param {Object} options.eventData 业务埋点数据,只有指定了eventKey之后才有效[非必填]
     * @param {Object} options.ext ceiba组件内扩展埋点
     */
    reportClickRaw({ state }, options = {}) {
      const ceibaBaseExt = {
        ceiba_business_id: state.actInfo.ast,
        ceiba_activity_id: state.actInfo.activity_id,
        ceiba_page_id: state.actInfo.page_id,
        ceiba_activity_type: state.actInfo.activity_type,
        ceiba_is_truly_login: state.isLogin,
      };
      ceibaBaseExt.ceiba_component_id = options.ceibaComponentId;
      ceibaBaseExt.ceiba_component_uid = options.ceibaComponentUid;
      ceibaBaseExt.ceiba_component_uname = options.ceibaComponentUname;
      // ceiba组件通用点击event_id
      const eventId = options.eventId || state.actInfo?.report_config[options.eventKey]?.event_id || 1045;
      let ceibaExtExt = {};
      if (state.actInfo?.report_config[options.eventKey]?.event_id) {
        // 传入了有效的eventKey,则自己构造ext
        ceibaExtExt = {
          sub_type: options.eventKey,
          data: options.eventData,
        };
      } else {
        // 无有效eventKey,取传入的ext
        ceibaExtExt = options.ext;
      }
      ceibaBaseExt.ext = JSON.stringify(ceibaExtExt);
      const eventType = options.eventType || 1002;
      const trackClickOption = {
        page_id: window.reportPageId,
        activity_id: state.actInfo.uo_id, // 增加上报uo活动id
        event_id: eventId,
        event_type: eventType,
        ext: { ...reportExt, ...ceibaExtExt?.data },
        game_id: String(state.actInfo?.gid), // 取心悦gid为game_id
        data_id: state.actInfo.report_config[`${eventId}`],
        ceiba_ext: JSON.stringify(ceibaBaseExt),
      };
      window.ceibaReporter && window.ceibaReporter?.trackClick(trackClickOption);
      if (ceibaBaseExt.ceiba_component_uid && state.actInfo.flattenComponents) {
        trackClickOption.component_config = state.actInfo.flattenComponents[ceibaBaseExt.ceiba_component_uid] || {};
      }
      Vue.prototype.$report?.trackClick(trackClickOption);
    },
    /**
     * 封装ceiba曝光事件上报,暴露部分mantaSDK原始参数
     * @param {Object} param0 解构store公共方法
     * @param {Object} options 需要业务传入的参数
     * @param {Object} options.ele 需要计算曝光的html节点
     * @param {String} options.ceibaComponentId ceiba组件注册id
     * @param {String} options.ceibaComponentUid ceiba组件实例化uuid
     * @param {String} options.ceibaComponentUname ceiba组件实例化name
     * @param {String} options.eventId 产品事先申请,约定好的事件id[非必填]
     * @param {String} options.eventType 产品事先申请,约定好的事件type[非必填]
     * @param {String} options.eventKey 产品事先申请,约定好的事件英文key,优先级比eventId低.当没有指定eventId时尝试从此参数获取eventId[非必填]
     * @param {Object} options.eventData 业务埋点数据,只有指定了eventKey之后才有效[非必填]
     * @param {Object} options.ext ceiba组件内扩展埋点
     */
    reportExposeRaw({ state }, options = {}) {
      const ceibaBaseExt = {
        ceiba_business_id: state.actInfo.ast,
        ceiba_activity_id: state.actInfo.activity_id,
        ceiba_page_id: state.actInfo.page_id,
        ceiba_activity_type: state.actInfo.activity_type,
        ceiba_is_truly_login: state.isLogin,
      };
      ceibaBaseExt.ceiba_component_id = options.ceibaComponentId;
      ceibaBaseExt.ceiba_component_uid = options.ceibaComponentUid;
      ceibaBaseExt.ceiba_component_uname = options.ceibaComponentUname;
      // ceiba组件通用点击event_id
      const eventId = options.eventId || state.actInfo?.report_config[options.eventKey]?.event_id || 1044;
      let ceibaExtExt = {};
      if (state.actInfo?.report_config[options.eventKey]?.event_id) {
        // 传入了有效的eventKey,则自己构造ext
        ceibaExtExt = {
          sub_type: options.eventKey,
          data: options.eventData,
        };
      } else {
        // 无有效eventKey,取传入的ext
        ceibaExtExt = options.ext;
      }
      ceibaBaseExt.ext = JSON.stringify(ceibaExtExt);
      const eventType = options.eventType || 1001;
      const trackClickOption = {
        page_id: window.reportPageId,
        activity_id: state.actInfo.uo_id, // 增加上报uo活动id
        event_id: eventId,
        ext: { ...reportExt, ...ceibaExtExt?.data },
        event_type: eventType,
        game_id: String(state.actInfo?.gid), // 取心悦gid为game_id
        data_id: state.actInfo.report_config[`${eventId}`],
        ceiba_ext: JSON.stringify(ceibaBaseExt),
      };
      window.ceibaReporter && window.ceibaReporter?.expose(options.ele, trackClickOption);
      if (ceibaBaseExt.ceiba_component_uid && state.actInfo.flattenComponents) {
        trackClickOption.component_config = state.actInfo.flattenComponents[ceibaBaseExt.ceiba_component_uid] || {};
      }
      Vue.prototype.$report?.trackClick(trackClickOption);
    },
    /**
     * 封装自定义事件上报
     * @param {Object} param0 解构store公共方法
     * @param {Object} options 需要业务传入的参数
     * @param {Number} options.eventId 产品事先申请,约定好的事件id[非必填].与eventKey属性二选一必填.
     * @param {Number} options.eventType 产品事先申请,约定好的事件type
     * @param {String} options.eventKey 产品事先申请,约定好的事件英文key,优先级比eventId低.当没有指定eventId时尝试从此参数获取eventId[非必填]
     * @param {Object} options.eventData 业务埋点数据,只有指定了eventKey之后才有效[非必填]
     * @param {String} options.ceibaComponentId ceiba组件注册id
     * @param {String} options.ceibaComponentUid ceiba组件实例化uuid
     * @param {String} options.ceibaComponentUname ceiba组件实例化name
     * @param {Object} options.ext ceiba组件内扩展埋点
     */
    reportCustomEvent({ state }, options = {}) {
      const ceibaBaseExt = {
        ceiba_business_id: state.actInfo.ast,
        ceiba_activity_id: state.actInfo.activity_id,
        ceiba_page_id: state.actInfo.page_id,
        ceiba_activity_type: state.actInfo.activity_type,
        ceiba_is_truly_login: state.isLogin,
      };
      ceibaBaseExt.ceiba_component_id = options.ceibaComponentId;
      ceibaBaseExt.ceiba_component_uid = options.ceibaComponentUid;
      ceibaBaseExt.ceiba_component_uname = options.ceibaComponentUname;
      let ceibaExtExt = {};
      if (state.actInfo?.report_config[options.eventKey]?.event_id) {
        // 传入了有效的eventKey,则自己构造ext
        ceibaExtExt = {
          sub_type: options.eventKey,
          data: options.eventData,
        };
      } else {
        // 无有效eventKey,取传入的ext
        ceibaExtExt = options.ext;
      }
      ceibaBaseExt.ext = JSON.stringify(ceibaExtExt);
      const eventId = options.eventId || state.actInfo?.report_config[options.eventKey]?.event_id;
      // 自定义点击事件上报
      const trackClickOption = {
        page_id: window.reportPageId,
        activity_id: state.actInfo.uo_id, // 增加上报uo活动id
        event_id: eventId,
        ext: { ...reportExt, ...ceibaExtExt?.data },
        game_id: String(state.actInfo?.gid), // 取心悦gid为game_id
        data_id: state.actInfo.report_config[`${eventId}`],
        ceiba_ext: JSON.stringify(ceibaBaseExt),
      };
      if (options.eventType) {
        trackClickOption.event_type = options.eventType;
      }
      window.ceibaReporter && window.ceibaReporter?.trackClick(trackClickOption);
      if (ceibaBaseExt.ceiba_component_uid && state.actInfo.flattenComponents) {
        trackClickOption.component_config = state.actInfo.flattenComponents[ceibaBaseExt.ceiba_component_uid] || {};
      }
      Vue.prototype.$report?.trackClick(trackClickOption);
    },
    updatePageId({ commit }, pageId) {
      commit('UPDATE_PAGE_ID', pageId);
    },
    assignUserInfo({ commit }, userInfo) {
      commit('ASSIGN_USER_INFO', userInfo);
    },
  },
  mutations: {
    UPDATE_CUSTOM_STORE(state, key, data) {
      state.customStore[key] = data;
    },
    UPDATE_QUA_INFO(state, quaInfo) {
      state.quaInfo = quaInfo;
      console.log('emit ceiba:common:events:qua-refreshed quaInfo', quaInfo);
      Vue.prototype.$eventBus.$emit('ceiba:common:events:qua-refreshed', null);
    },
    UPDATE_IS_ROLE_READY(state, isRoleReady) {
      state.isRoleReady = isRoleReady;
      if (isRoleReady) {
        Vue.prototype.$eventBus.$emit('ceiba:common:events:role-ready', null);
      }
    },
    UPDATE_ROLE_INFO(state, roleInfo) {
      state.roleInfo = roleInfo;
      console.log('UPDATE_ROLE_INFO|', roleInfo);
    },
    UPDATE_IS_LOGIN(state, isLogin) {
      state.isLogin = isLogin;
      if (isLogin) {
        Vue.prototype.$eventBus.$emit('ceiba:common:events:logined', null);
      } else {
        Vue.prototype.$eventBus.$emit('ceiba:common:events:logout', null);
      }
    },
    UPDATE_USER_INFO(state, userInfo) {
      state.userInfo = userInfo;
    },
    ASSIGN_USER_INFO(state, userInfo) {
      state.userInfo = Object.assign(state.userInfo, userInfo);
    },
    UPDATE_ACTINFO(state, actInfo) {
      state.actInfo = actInfo;
      // 生成当前进入页面的trace_id
      if (!reportExt.trace_id) {
        // 生成uid
        reportExt.trace_id = `CEIBA-${common.tool.uuid().replaceAll('-', '')}-${actInfo.uo_id}`;
      }
    },
    UPDATE_PAGE_ID(state, pageId) {
      state.actInfo.page_id = pageId;
    },
  },
});
